import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./wishlist.module.css";
import WishListCard from "./WishListCard/WishListCard";
import {
  Loader,
  Pagination,
  SubHeadingTitle,
} from "../../../../components/shared/index";
import {
  useGetWishLists,
  useRemoveWishList,
} from "../../../../queries/useWishListQuery";
import { getImageUrl } from "../../../../lib/get-image";
import { useAddToCart ,  useGetCart} from "../../../../queries/useCartQuery";
import toast from "react-hot-toast";
import authService from "../../../../services/authService";
import productStockNotificationService from "../../../../services/productNotifyService";

const WishList = () => {
    const navigate = useNavigate();

  const { data: wishListItems, isPending, error } = useGetWishLists();
  const { mutate: addToCart, isPending: isCartPending } = useAddToCart();
  const { data: cartItems = [] } = useGetCart();
  const [notifiedItemIds, setNotifiedItemIds] = useState([]);
  const [loadingItemId, setLoadingItemId] = useState(null);
  const { mutate: removeWish } = useRemoveWishList();
  const [currentPage, setCurrentPage] = useState(1);
  const per_page = 5;

  if (isPending) {
    return <Loader title="Loading wishlist..." />;
  }

  if (error) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
        <p>Failed to load wishlist.</p>
        <p>{error?.message || "Something went wrong"}</p>
      </div>
    );
  }

const formattedWishList = wishListItems?.map((item) => {
    const originalPrice = Number(item.product?.price);
    const offerPrice = Number(item?.product?.offer_price);
    const hasOffer = offerPrice > 0;

    // NEW
    const isInCart = cartItems.some(
      (cartItem) => cartItem.product_id === item.product.id
    );

    return {
      id: item?.id,
      productId: item?.product?.id,
      productQuantity: item?.product?.qty,
      productSlug: item?.product?.slug,
      image: getImageUrl(item.product?.thumb_image),
      title: item?.product?.name,
      size: item?.product?.qty || "N/A",
      sku: item?.product?.sku,
      price: hasOffer ? offerPrice : originalPrice,
      oldPrice: hasOffer ? originalPrice : null,
      offer: hasOffer
        ? Math.round(((originalPrice - offerPrice) / originalPrice) * 100)
        : 0,

      // NEW
      isInCart,
    };
  });

const handleAddToCart = (item) => {
  if (!item.productId) {
    toast.error("Product ID missing");
    return;
  }

  setLoadingItemId(item.id);

  addToCart(
    {
      product_id: item?.productId,
      quantity: 1,
    },
    {
      onSuccess: () => {
        toast.success("Item added to cart");
      },
      onError: () => {
        toast.error("Failed to add item to cart");
      },
      onSettled: () => {
        setLoadingItemId(null);
      },
    }
  );
};
const handleNotifyMe = async (item) => {
  if (!item.productId) {
    toast.error("Product ID missing");
    return;
  }

  // Only logged-in users can call the notification API
  if (!authService.isLoggedIn()) {
    toast.error("Please login to get notified when this product is back in stock.");
    return;
  }

  try {
    setLoadingItemId(item.id);

  await productStockNotificationService.subscribe({
  productId: item.productId,
});

// Mark this wishlist item as notified
setNotifiedItemIds((prev) => [...prev, item.id]);

toast.success("We'll notify you when this product is back in stock.");
  } catch (error) {
    console.error("Notify Me Error:", error);

    toast.error(
      error?.message || "Failed to subscribe for stock notification."
    );
  } finally {
    setLoadingItemId(null);
  }
};
  const indexOfLast = currentPage * per_page;
  const indexOfFirst = indexOfLast - per_page;

  const currentItems = formattedWishList?.slice(indexOfFirst, indexOfLast);

  return (
    <div className={styles.wrapper}>
      <div className={styles.listWrapper}> 
        <div> 
          
        </div>
     {formattedWishList.length === 0 ? (
 <div className={styles.emptyWishlist}>
  <p className={styles.emptyWishlistText}>
    Your wishlist is empty
  </p>

  <button
    className={styles.continueShoppingBtn}
    onClick={() => navigate("/shop")}
  >
    Start Shopping
  </button>
</div>
) : (
          currentItems.map((item) => (
            <WishListCard
              key={item.id}  
              item={item}
              isCartPending={loadingItemId === item.id}
                isInCart={item.isInCart}
                  isNotified={notifiedItemIds.includes(item.id)}
              onAddToCart={() => handleAddToCart(item)}
               onNotifyMe={() => handleNotifyMe(item)}
              onRemove={() => removeWish(item?.id)}
            />
          ))
        )}
      </div>

      {formattedWishList.length > per_page && (
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            total={wishListItems?.length}
            per_page={per_page}
            handlePageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default WishList;